/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelServizioOperatoreAssegnazioneDTO } from '../model/models';
import { ServizioOperatoreAssegnazioneCreationForm } from '../model/models';
import { ServizioOperatoreAssegnazioneDTO } from '../model/models';
import { ServizioOperatoreAssegnazionePatchForm } from '../model/models';
import { ServizioOperatoreScuoleDTO } from '../model/models';
import { ServizioOperatoreScuoleReplaceForm } from '../model/models';
import { ServizioOperatoriBulkReplaceForm } from '../model/models';
import { ServizioOperatoriListFilter } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface BulkReplaceServizioOperatoriRequestParams {
    idServizio: string;
    servizioOperatoriBulkReplaceForm: ServizioOperatoriBulkReplaceForm;
}

export interface CreateServizioOperatoreRequestParams {
    idServizio: string;
    servizioOperatoreAssegnazioneCreationForm: ServizioOperatoreAssegnazioneCreationForm;
}

export interface DeleteServizioOperatoreRequestParams {
    idServizio: string;
    userId: string;
}

export interface GetServizioOperatoreScuoleRequestParams {
    idServizio: string;
    userId: string;
}

export interface ListServizioOperatoriRequestParams {
    idServizio: string;
    filter: ServizioOperatoriListFilter;
    pageable: Pageable;
}

export interface ReplaceServizioOperatoreScuoleRequestParams {
    idServizio: string;
    userId: string;
    servizioOperatoreScuoleReplaceForm: ServizioOperatoreScuoleReplaceForm;
}

export interface UpdateServizioOperatoreRequestParams {
    idServizio: string;
    userId: string;
    servizioOperatoreAssegnazionePatchForm: ServizioOperatoreAssegnazionePatchForm;
}


export interface ServizioOperatoriServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Bulk replace delle assegnazioni del servizio.
     * Optimistic lock sulla @Version del parent Servizio. Semantica omessi-rimossi: items non presenti vengono cancellati, items nuovi creati, items invariati restano. Transazione singola.
     * @endpoint put /api/v1/gestione/servizi/{id_servizio}/operatori
* @param requestParameters
     */
    bulkReplaceServizioOperatori(requestParameters: BulkReplaceServizioOperatoriRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioOperatoreAssegnazioneDTO>>;

    /**
     * Assegna un operatore esistente al servizio.
     * Audience: SUPERADMIN, OP_COMUNE (solo nei propri comuni). Target deve essere gia\&#39; un operatore-servizio mensa (OP_SCUOLA o OP_CENTRO_COTTURA).
     * @endpoint post /api/v1/gestione/servizi/{id_servizio}/operatori
* @param requestParameters
     */
    createServizioOperatore(requestParameters: CreateServizioOperatoreRequestParams, extraHttpRequestParams?: any): Observable<ServizioOperatoreAssegnazioneDTO>;

    /**
     * Revoca l\&#39;assegnazione (idempotente).
     * 204 sia se la riga esisteva e viene cancellata, sia se non esisteva.
     * @endpoint delete /api/v1/gestione/servizi/{id_servizio}/operatori/{user_id}
* @param requestParameters
     */
    deleteServizioOperatore(requestParameters: DeleteServizioOperatoreRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Scuole assegnate a un operatore su questo servizio.
     * Audience: SUPERADMIN, OP_COMUNE (solo nei propri comuni). Ritorna le scuole assegnate all\&#39;operatore piu\&#39; la copertura sul totale assegnabile (scuole di plesso attivo). Un insieme vuoto su un OP_SCUOLA significa che l\&#39;operatore NON vede alcun dato del servizio (gate fail-closed), non che la configurazione e\&#39; assente.
     * @endpoint get /api/v1/gestione/servizi/{id_servizio}/operatori/{user_id}/scuole
* @param requestParameters
     */
    getServizioOperatoreScuole(requestParameters: GetServizioOperatoreScuoleRequestParams, extraHttpRequestParams?: any): Observable<ServizioOperatoreScuoleDTO>;

    /**
     * Lista paginata operatori assegnati al servizio.
     * Filtri opzionali: q, ruolo. Default sort: user.cognome ASC, user.nome ASC.
     * @endpoint get /api/v1/gestione/servizi/{id_servizio}/operatori
* @param requestParameters
     */
    listServizioOperatori(requestParameters: ListServizioOperatoriRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioOperatoreAssegnazioneDTO>;

    /**
     * Sostituisce le scuole assegnate a un operatore su questo servizio.
     * Audience: SUPERADMIN, OP_COMUNE (solo nei propri comuni). Replace, non merge: l\&#39;insieme inviato diventa quello vigente. scuole_ids vuoto e\&#39; ammesso e REVOCA l\&#39;accesso dell\&#39;operatore ai dati del servizio (gate fail-closed) - l\&#39;interfaccia deve dichiararlo prima di salvare. Ogni id deve appartenere a questo servizio (404 sul primo estraneo). Non applicabile a OP_CENTRO_COTTURA, che vede sempre tutte le scuole (400). version e\&#39; quella del Servizio parent.
     * @endpoint put /api/v1/gestione/servizi/{id_servizio}/operatori/{user_id}/scuole
* @param requestParameters
     */
    replaceServizioOperatoreScuole(requestParameters: ReplaceServizioOperatoreScuoleRequestParams, extraHttpRequestParams?: any): Observable<ServizioOperatoreScuoleDTO>;

    /**
     * Aggiorna la riga di assegnazione (optimistic lock).
     * version client-driven sulla riga user_servizio. Se ruolo_servizio e\&#39; presente deve coincidere con l\&#39;authority del target.
     * @endpoint patch /api/v1/gestione/servizi/{id_servizio}/operatori/{user_id}
* @param requestParameters
     */
    updateServizioOperatore(requestParameters: UpdateServizioOperatoreRequestParams, extraHttpRequestParams?: any): Observable<ServizioOperatoreAssegnazioneDTO>;

}
